<div class="component">
    <h2>Info Popup</h2>
    <div *ngIf="test">Clicked</div>
    <sbw-info-popup heading="Header">
        <h2>Some Header</h2>
        <p>Something</p>
        <sbw-button type="preferred" text="Do stuff" (click)="test=true"></sbw-button>
    </sbw-info-popup>
</div>
